import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { AlumniEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/alumni' };

export const RiskAlumniStore = createRestStore<AlumniEntity>({
  name: 'risk-alumni-store',
  actions: createRestActions<AlumniEntity>(actionConfig),
  actionConfig,
  containerDisplayName: 'risk-alumni-container',
  onInitAction: null,
});

export const useRiskAlumniData = createDataHook(RiskAlumniStore);
export const useRiskAlumniIsLoading = createLoadingHook(RiskAlumniStore);
export const useRiskAlumniActions = createActionsHook(RiskAlumniStore);
export const didRiskAlumniMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
